export const isContentType = <T extends { type: string }>(
  slide: unknown,
  type: T['type'],
): slide is T => {
  return Boolean(
    typeof slide === 'object' && slide && (slide as T).type === type,
  );
};
